import { forwardRef, useEffect, useRef } from "react";

import styled from "styled-components";

const SDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  row-gap: 4px;
  column-gap: 2px;
  margin: 4px;

  & > button {
    width: var(--button-width);
  }
`;

const NavLinksWrapper = forwardRef(
  ({ children, minWidth = 0, ...rest }, ref) => {
    const localRef = useRef();
    const containerRef = ref || localRef;

    useEffect(() => {
      if (!containerRef.current) return;

      const updateWidths = () => {
        if (!containerRef.current) return;
        const localButtons = Array.from(
          containerRef.current.querySelectorAll("button")
        );
        const maxWidth = Math.max(
          ...localButtons.map((b) => b.offsetWidth),
          minWidth
        );
        containerRef.current.style.setProperty(
          "--button-width",
          `${maxWidth}px`
        );
      };

      updateWidths();

      const resizeObserver = new ResizeObserver(updateWidths);

      // Use MutationObserver to watch for button additions/removals
      const mutationObserver = new MutationObserver(() => {
        const localButtons = containerRef.current?.querySelectorAll("button");
        if (localButtons) {
          localButtons.forEach((btn) => resizeObserver.observe(btn));
          updateWidths();
        }
      });

      const buttons = containerRef.current.querySelectorAll("button");
      buttons.forEach((btn) => resizeObserver.observe(btn));

      mutationObserver.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });

      return () => {
        resizeObserver.disconnect();
        mutationObserver.disconnect();
      };
    }, [containerRef, minWidth]);

    return (
      <SDiv ref={containerRef} {...rest}>
        {children}
      </SDiv>
    );
  }
);

export default NavLinksWrapper;
